import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HvlBuildInfoService, HvlNgCoreModule, HvlValidNotationService } from '@hvlng/framework-bff/core';
import { HvlMultiTranslateHttpLoader, HvlNgLanguageModule } from '@hvlng/framework-core/language';

import { PrimengSharedModule } from '@hvlng/framework-core/shared';
import { HvlBreadcrumbService, HvlMenuService, HvlNgFrameworkThemeModule } from '@hvlng/framework-theme';
import { HvlNgSecurityModule } from '@hvlng/framework-bff/security';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { CalendarFooterButtonModule, HumanresourcesCommonSharedModule } from 'humanresources-common-shared';
import { InfrastructureSharedModule } from 'infrastructure-shared';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';

import { KovanGlobalErrorHandler, UiPreloaderModule, UiSharedModule } from 'ui-shared';
import { HrRecMainComponent } from './hr-rec-main.component';
import { HrRecRootComponent } from './hr-rec-root.component';
import { environment } from '../environments/environment';
import { HrRecAppRoutingModule } from './hr-rec-app-routing.module';
import { IntegrationSharedModule } from 'integration-shared';
import { HvlNgBaseModule } from '@hvlng/framework-core/base';
import {
    HumanresourcesPersonnelSharedModule
} from 'humanresources-personnel-shared';
import { HumanresourcesPublicSharedModule } from 'humanresources-public-shared';
import { FinanceSharedModule } from 'finance-shared';
import { LogisticPublicSharedModule } from 'logistic-public-shared';
export function appConfigInit(toastCleaner: UiToastCleanerService, configSetterService: ConfigSetterService) {
    return () => {
        toastCleaner.init();
        return configSetterService.loadConfig();
    };
}
import { UiToastCleanerService } from '@kovan/ui-shared';
import { ConfigSetterService } from 'theme';
import { AppLayoutModule } from '@kovan/theme';
export function ModuleHttpLoaderFactory(http: HttpClient, hvlBuildInfoService: HvlBuildInfoService) {
    return new HvlMultiTranslateHttpLoader(
        http,
        [
            { prefix: './assets/i18n/common/', suffix: '.json' },
            { prefix: './assets/i18n/', suffix: '/toast.json' },
            { prefix: './assets/i18n/', suffix: '/ui-shared.json' },
            { prefix: './assets/i18n/', suffix: '/infrastructure-shared.json' },
            { prefix: './assets/i18n/', suffix: '/humanresources-common-shared.json' },
            { prefix: './assets/i18n/', suffix: '/humanresources-personnel-shared.json' },
            { prefix: './assets/i18n/', suffix: '/humanresources-recruitment.json' },
            { prefix: './assets/i18n/', suffix: '/humanresources-personnel.json' },
            { prefix: './assets/i18n/', suffix: '/humanresources-public-shared.json' },
            { prefix: './assets/i18n/', suffix: '/infrastructure.json' },
            { prefix: './assets/i18n/form-message/', suffix: '.json' },
        ],
        hvlBuildInfoService,
    );
}

@NgModule({
    declarations: [HrRecMainComponent, HrRecRootComponent],
    imports: [
        HrRecAppRoutingModule,
        AppLayoutModule,
        UiSharedModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        HvlNgSecurityModule.forRoot(),
        HvlNgBaseModule.forRoot(),
        HvlNgLanguageModule.forRoot(),
        HvlNgFrameworkThemeModule,
        ToastModule,
        ConfirmDialogModule,
        HvlNgCoreModule.forRoot(environment),

        FinanceSharedModule.forRoot(),
        LogisticPublicSharedModule.forRoot(),
        HumanresourcesCommonSharedModule.forRoot(),
        HumanresourcesPersonnelSharedModule.forRoot(),
        InfrastructureSharedModule.forRoot(),
        IntegrationSharedModule.forRoot(),
        HumanresourcesPublicSharedModule.forRoot(),
        CalendarFooterButtonModule.forRoot(),
        PrimengSharedModule,
        TableModule,
        ConfirmDialogModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: ModuleHttpLoaderFactory,
                deps: [HttpClient, HvlBuildInfoService],
            },
            isolate: false,
            extend: true,
        }),
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: ErrorHandler, useClass: KovanGlobalErrorHandler },
        HvlMenuService,
        HvlBreadcrumbService,
        HvlValidNotationService,
        {
            provide: APP_INITIALIZER,
            useFactory: appConfigInit,
            deps: [UiToastCleanerService, ConfigSetterService],
            multi: true,
        },
    ],
    bootstrap: [HrRecRootComponent],
})
export class HrRecAppModule {}
